export default __webpack_public_path__ + "static/media/bg-signup.0d63fd3c.png";